import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { Calendar, DateObject } from 'react-multi-date-picker';
import moment from 'moment';
import Dropdown from '../../base/Dropdown/Dropdown';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import gregorian_ru from './gregorian_ru';
import TextInput from '../TextInput/TextInput';
import './RangeDatePickerStyles.scss';

export default function RangeDatePicker(props) {
  const {
    className = '',
    inline = false,
    hidePeriodButtons = false,
    inputProps = {},
    fieldState = {
      error: '',
      touched: false,
    },
    usePortal = false,
    placeholder = '',
    changeFormat = null,
    onChangeToIso = false,
  } = props;
  const { formatMessage } = useIntl();
  const { onChange = () => {}, name, value } = inputProps;
  const {
    isTouched: touched,
  } = fieldState;
  const [values, setValues] = useState([]);

  useEffect(() => {
    const defaultValue = value && value.length && value.every(obj => typeof obj === 'string')
      ? [
        new DateObject(moment(value[0]).startOf('day').toDate()),
        new DateObject(moment(value[1]).endOf('day').toDate()),
      ] : [];
    setValues(defaultValue);
  }, [value]);

  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [pickerKey, setPickerKey] = useState(null);
  const pickerRef = useRef(null);
  const [start, end] = values;
  const onSelect = range => {
    if (range && range.length && range.length > 1) {
      setValues(range);
      const [start, end] = range;
      if (changeFormat) {
        onChange({ target: { value: [start.format(changeFormat), end.format(changeFormat)], name } });
      } else if (onChangeToIso) {
        onChange({ target: { value: start && end ? [moment(start.toDate()).startOf('day').toISOString(), moment(end.toDate()).endOf('day').toISOString()] : '', name } });
      } else {
        onChange({ target: { value: range, name } });
      }
    }
  };
  const handleChangeDate = range => {
    setSelectedPeriod(null);
    onSelect(range);
  };
  const onReset = event => {
    setValues('');
    setSelectedPeriod('');
    onChange({ target: { value: '', name } });
    event.stopPropagation();
  };
  const anchorElement = useRef(null);

  const handleSelectPeriod = type => () => {
    const today = moment();
    let start = today.clone().startOf('day');
    let end = today.clone().endOf('day');
    if (type === 'y') {
      start = today.clone().startOf('year');
      end = today.clone().endOf('year');
    }
    if (type === 'm') {
      start = today.clone().startOf('month');
      end = today.clone().endOf('month');
    }
    if (type === 'w') {
      start = today.clone().startOf('week');
      end = today.clone().endOf('week');
    }
    if (type === 'yd') {
      start = today.clone().startOf('days')
        .subtract(1, 'days');
      end = today.clone().endOf('days')
        .subtract(1, 'days');
    }
    setSelectedPeriod(type);
    onSelect([new DateObject({ date: start.toDate() }), new DateObject({ date: end.toDate() })]);
    setTimeout(() => {
      setPickerKey(pickerKey + 1);
    }, 50);
  };

  const startText = start && start.format ? start.format('DD.MM.YYYY') : '';
  const endText = end && end.format ? end.format('DD.MM.YYYY') : '';
  const isError = false;
  const textValue = (!startText || !endText) ? '' : `${startText} — ${endText}`;
  return (
    <div className={classNames('form-control-wrapper range-date-picker', { 'inline-picker': inline }, className)}>
      <div className="custom-react-date-picker">
        <Dropdown usePortal={usePortal}>
          <Dropdown.Toggle target={pickerRef && pickerRef.current ? pickerRef.current : null}>
            <div ref={anchorElement} className="date-selector-wrapper">
              <div className="date-selector">
                <TextInput
                  {...props}
                  readOnly
                  inputAfter={textValue ? (
                    <div className="search-wrapper">
                      <Icons customIcon onClick={onReset} width={18} height={18} icon="close" />
                    </div>
                  ) : null}
                  className={classNames('data-picker-text', { 'is-invalid': isError && touched })}
                  containerRef={pickerRef}
                  placeholder={placeholder}
                  inputProps={{
                    onChange: () => {},
                    value: textValue,
                  }}
                />
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu anchorElement={anchorElement} disableClickToggle className="data-picker-wrapper">
            <Calendar
              key={pickerKey}
              value={values}
              onChange={handleChangeDate}
              locale={gregorian_ru}
              range
              rangeHover
              weekStartDayIndex={1}
            />
            {!hidePeriodButtons
              ? (
                <div className="data-picker-filter-buttons">
                  <span
                    className={classNames('data-picker-filter-button', { active: selectedPeriod === 'yd' })}
                    onClick={handleSelectPeriod('yd')}
                  >
                    {formatMessage({ id: 'yesterday' })}
                  </span>
                  <span
                    className={classNames('data-picker-filter-button', { active: selectedPeriod === 'd' })}
                    onClick={handleSelectPeriod('d')}
                  >
                    {formatMessage({ id: 'today' })}
                  </span>
                  <span
                    className={classNames('data-picker-filter-button', { active: selectedPeriod === 'w' })}
                    onClick={handleSelectPeriod('w')}
                  >
                    {formatMessage({ id: 'week' })}
                  </span>
                  <span
                    className={classNames('data-picker-filter-button', { active: selectedPeriod === 'm' })}
                    onClick={handleSelectPeriod('m')}
                  >
                    {formatMessage({ id: 'month' })}
                  </span>
                  <span
                    className={classNames('data-picker-filter-button', { active: selectedPeriod === 'y' })}
                    onClick={handleSelectPeriod('y')}
                  >
                    {formatMessage({ id: 'year' })}
                  </span>
                  <span
                    className={classNames('data-picker-filter-button reset')}
                    onClick={onReset}
                  >
                    {formatMessage({ id: 'clear' })}
                  </span>
                </div>
              )
              : null}
          </Dropdown.Menu>
        </Dropdown>

      </div>
    </div>
  );
}
